/* ══ THE STORY SHOP — THEME JS ══ */
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) refreshCart();
});

/* ── Custom Cursor ── */
const dot  = document.getElementById('cursor-dot');
const ring = document.getElementById('cursor-ring');
let ringX = 0, ringY = 0, dotX = 0, dotY = 0;

if (dot && ring) {
  document.addEventListener('mousemove', e => {
    dotX = e.clientX; dotY = e.clientY;
  });

  function animateCursor() {
    ringX += (dotX - ringX) * 0.12;
    ringY += (dotY - ringY) * 0.12;
    dot.style.left  = dotX + 'px';
    dot.style.top   = dotY + 'px';
    ring.style.left = ringX + 'px';
    ring.style.top  = ringY + 'px';
    requestAnimationFrame(animateCursor);
  }
  animateCursor();

  document.querySelectorAll('a, button, .genre-tile, .book-card, .shelf-book, .nav-link, .arabic-card').forEach(el => {
    el.addEventListener('mouseenter', () => document.body.classList.add('hovering'));
    el.addEventListener('mouseleave', () => document.body.classList.remove('hovering'));
  });
}

/* ── Scroll Progress ── */
const progressBar = document.getElementById('progress');
if (progressBar) {
  window.addEventListener('scroll', () => {
    const pct = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
    progressBar.style.width = pct + '%';
  });
}

/* ── Hero Word Reveal ── */
const heroTitleEl = document.getElementById('heroTitle');
if (heroTitleEl) {
  const heroWords = ["Your", "next", "favourite", "book", "is", "<em>already</em>", "<em>here.</em>"];
  let delay = 0.35;
  heroWords.forEach(w => {
    const span = document.createElement('span');
    span.className = 'word';
    span.innerHTML = `<span class="word-inner" style="animation-delay:${delay}s">${w}</span>`;
    heroTitleEl.appendChild(span);
    delay += 0.1;
  });
}

/* ── Hero Mouse Parallax ── */
const heroEl = document.getElementById('hero');
if (heroEl) {
  const floats = heroEl.querySelectorAll('.hero-float');
  heroEl.addEventListener('mousemove', e => {
    const cx = heroEl.offsetWidth / 2;
    const cy = heroEl.offsetHeight / 2;
    const dx = e.clientX - cx;
    const dy = e.clientY - cy;
    floats.forEach(f => {
      const s = parseFloat(f.dataset.speed);
      f.style.transform = `translate(${dx * s}px, ${dy * s}px)`;
    });
  });
  heroEl.addEventListener('mouseleave', () => {
    floats.forEach(f => f.style.transform = 'translate(0,0)');
  });
}

/* ── Shelf Track Builder ── */
const shelfTrack = document.getElementById('shelfTrack');
if (shelfTrack) {
  const imgs = Array.from(shelfTrack.querySelectorAll('img'));
  const dupe = imgs.map(img => {
    const div = document.createElement('div');
    div.className = 'shelf-book';
    const i = document.createElement('img');
    i.src = img.src;
    i.alt = img.alt;
    i.loading = 'lazy';
    div.appendChild(i);
    return div;
  });
  dupe.forEach(d => shelfTrack.appendChild(d));
}

/* ── Magnetic Buttons ── */
document.querySelectorAll('.btn-magnetic').forEach(wrap => {
  const btn = wrap.querySelector('a');
  if (!btn) return;
  wrap.addEventListener('mousemove', e => {
    const r = wrap.getBoundingClientRect();
    const x = e.clientX - r.left - r.width / 2;
    const y = e.clientY - r.top - r.height / 2;
    btn.style.transform = `translate(${x * 0.28}px, ${y * 0.28}px)`;
  });
  wrap.addEventListener('mouseleave', () => {
    btn.style.transform = 'translate(0,0)';
    btn.style.transition = 'transform 0.5s cubic-bezier(0.16,1,0.3,1)';
  });
  wrap.addEventListener('mouseenter', () => {
    btn.style.transition = 'transform 0.1s linear';
  });
});

/* ── 3D Card Tilt ── */
function initTilt(cards) {
  cards.forEach(card => {
    const inner = card.querySelector('.book-card-inner') || card.querySelector('.arabic-card-inner');
    if (!inner) return;
    card.addEventListener('mousemove', e => {
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      inner.style.transform = `rotateY(${x * 14}deg) rotateX(${-y * 14}deg) scale(1.02)`;
    });
    card.addEventListener('mouseleave', () => {
      inner.style.transform = '';
      inner.style.transition = 'transform 0.6s cubic-bezier(0.16,1,0.3,1)';
    });
    card.addEventListener('mouseenter', () => {
      inner.style.transition = 'transform 0.1s linear';
    });
  });
}

initTilt(document.querySelectorAll('.book-card'));
initTilt(document.querySelectorAll('.arabic-card'));

/* ── Scroll Animations ── */
const io = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('in-view');
      io.unobserve(e.target);
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.card-reveal, .reveal-title-inner').forEach(el => io.observe(el));

/* ══ SHOPIFY AJAX CART ══ */

function openCart() {
  document.getElementById('cartSidebar').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCart();
}

function closeCart() {
  document.getElementById('cartSidebar').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

async function refreshCart() {
  try {
    const cart = await window.StoryStock.inspectCart();
    renderCartSidebar(cart);
    updateCartBadge(cartItemCount(cart));
    document.querySelectorAll('[data-cart-line]').forEach(row => {
      const item = cart.items.find(item => item.key === row.dataset.cartLine);
      const badge = row.querySelector('[data-stock-label]');
      if (item && badge) {
        badge.textContent = item._stockState === 'preorder' ? 'Pre-Order'
          : item._stockState === 'unavailable' ? 'Currently unavailable' : '';
        badge.hidden = !badge.textContent;
      }
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  } catch (e) {
    // Keep the cart usable during a stock lookup outage, but do not claim stock.
    const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json()).catch(() => null);
    if (cart) {
      cart.items.forEach(item => { item._stockState = 'unknown'; });
      renderCartSidebar(cart);
      updateCartBadge(cartItemCount(cart));
    }
  }
}

// Both checkout links must reconcile saved labels before handing off to Shopify.
let checkingOut = false;
document.addEventListener('click', async function(event) {
  const link = event.target.closest('.btn-checkout, .btn-checkout-large');
  if (!link) return;
  event.preventDefault();
  if (checkingOut) return;
  checkingOut = true;
  const label = link.textContent;
  link.textContent = 'Checking stock…';
  link.setAttribute('aria-busy', 'true');
  try {
    const cart = await window.StoryStock.prepareCheckout();
    if (cart) window.location.assign(link.href);
  } catch (error) {
    window.alert(error.message);
  } finally {
    checkingOut = false;
    link.textContent = label;
    link.removeAttribute('aria-busy');
  }
}, true);

/* Real items only — the gift box is a fee, not something they picked */
function cartItemCount(cart) {
  return cart.items.filter(function(i) { return !isGiftItem(i); })
                   .reduce(function(n, i) { return n + i.quantity; }, 0);
}

/* Sale quantities are deliberately stricter than the cart badge. Accessories
   remain normal cart items, but only recognised book genres can unlock a
   book promotion. Keep this list aligned with the store's seven collections. */
const BOOK_PRODUCT_TYPES = [
  'Arabic', 'Romance', 'Fantasy', 'Dark Romance',
  'Business & Self-Help', 'Thriller', 'Classics'
];

function isBookItem(item) {
  return BOOK_PRODUCT_TYPES.indexOf((item && item.product_type) || '') !== -1;
}

function updateCartBadge(count) {
  document.querySelectorAll('.cart-count-badge').forEach(b => {
    b.textContent = count;
    b.classList.remove('pop');
    void b.offsetWidth;
    b.classList.add('pop');
  });
}

function renderCartSidebar(cart) {
  const body   = document.getElementById('cartBody');
  const label  = document.getElementById('cartCountLabel');
  const totEl  = document.getElementById('cartTotal');
  if (!body) return;

  // The gift box is a fee, not a product the customer browses for —
  // it's represented by the checkbox, never as a cart line.
  const items     = cart.items.filter(function(i) { return !isGiftItem(i); });
  const itemCount = items.reduce(function(n, i) { return n + i.quantity; }, 0);
  const bookCount = items.filter(isBookItem).reduce(function(n, i) { return n + i.quantity; }, 0);

  label && (label.textContent = itemCount + ' item' + (itemCount !== 1 ? 's' : ''));

  const nudge = document.getElementById('cartDiscountNudge');

  const upsell = document.getElementById('cartUpsell');

  if (itemCount === 0) {
    body.innerHTML = `
      <div class="cart-empty">
        <svg class="cart-empty-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
          <line x1="3" y1="6" x2="21" y2="6"/>
          <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>
        <p class="cart-empty-msg">Your cart is empty —<br>browse our collections</p>
      </div>`;
    totEl && (totEl.textContent = '$0');
    if (nudge) nudge.style.display = 'none';
    if (upsell) upsell.style.display = 'none';
    const emptyGift = document.getElementById('giftBlock');
    if (emptyGift) emptyGift.style.display = 'none';
    // A gift box with nothing left to wrap — take it back out
    if (cart.items.some(isGiftItem)) removeGiftBox().then(refreshCart);
    return;
  }

  if (nudge) {
    const C = window.CAMPAIGN;
    const celebOn = !!(C && Date.now() < new Date(C.end).getTime());

    /* Every offer this cart can reach, smallest basket first. During a
       celebration with a higher minimum the two ladder, so a reader who
       is short of the big one still sees what they have already earned. */
    const tiers = [];
    if (!celebOn || C.standing !== false) tiers.push({ min: 4, pct: '20%' });
    // A giveaway is not a discount tier: its percent/min are the standing offer.
    if (celebOn && C.kind !== 'giveaway') tiers.push({ min: C.minBooks, pct: C.percent + '%' });
    tiers.sort((a, b) => a.min - b.min);

    const check = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="margin-right:6px;vertical-align:-1px"><polyline points="20 6 9 17 4 12"/></svg>';
    const books = n => `${n} more book${n > 1 ? 's' : ''}`;

    const reached = tiers.filter(t => bookCount >= t.min).pop();
    const next    = tiers.find(t => bookCount < t.min);

    /* During a sale the nudge carries the same five-slot marks as the
       homepage stack and the product page — the whole store counts along. */
    const marks = (celebOn && C.kind === 'sale')
      ? '<span class="slot-marks is-row' + (bookCount >= C.minBooks ? ' is-unlocked' : '') + '" aria-hidden="true">' +
        Array.from({ length: C.minBooks }, (_, i) => '<i' + (i < bookCount ? ' class="on"' : '') + '></i>').join('') +
        '</span>'
      : '';

    if (reached && next) {
      nudge.className = 'cart-discount-nudge nudge-unlocked';
      nudge.innerHTML = marks + `${check}${reached.pct} off books unlocked — add ${books(next.min - bookCount)} for ${next.pct}`;
    } else if (reached) {
      nudge.className = 'cart-discount-nudge nudge-unlocked';
      nudge.innerHTML = marks + `${check}${reached.pct} off books unlocked — applies automatically at checkout`;
    } else {
      const after = tiers[tiers.indexOf(next) + 1];
      nudge.className = 'cart-discount-nudge nudge-pending';
      nudge.innerHTML = marks + (after
        ? `Add ${books(next.min - bookCount)} to unlock ${next.pct} off books — ${books(after.min - bookCount)} for ${after.pct}`
        : `Add ${books(next.min - bookCount)} to unlock ${next.pct} off books`);
    }
    nudge.style.display = 'block';
  }

  renderGiftState(cart);

  body.innerHTML = items.map((item, idx) => {
    const linePrice = (item.line_price / 100).toFixed(2).replace('.00', '');
    const state = item._stockState;
    const stockLabel = state === 'preorder' ? 'Pre-Order' : state === 'unavailable'
      ? 'Currently unavailable' : state === 'unknown' ? 'Stock check unavailable' : '';
    const preBadge = stockLabel ? '<span class="cart-item-preorder-badge">' + stockLabel + '</span>' : '';
    return `
      <div class="cart-item">
        <img class="cart-item-cover" src="${item.image}" alt="${item.product_title}">
        <div class="cart-item-info">
          <div class="cart-item-vendor">${item.vendor || ''}</div>
          <div class="cart-item-title">${esc(item.product_title)}${preBadge}</div>
          <div class="cart-item-bottom">
            <div class="cart-qty-wrap">
              <button class="cart-qty-btn" onclick="cartUpdateLine('${item.key}', ${item.quantity - 1})">−</button>
              <div class="cart-qty-val">${item.quantity}</div>
              <button class="cart-qty-btn" onclick="cartUpdateLine('${item.key}', ${item.quantity + 1})">+</button>
            </div>
            <div class="cart-item-line-price">$${linePrice}</div>
          </div>
        </div>
        <button class="cart-item-remove" onclick="cartUpdateLine('${item.key}', 0)" title="Remove">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>`;
  }).join('');

  const total = (cart.total_price / 100).toFixed(2).replace('.00', '');
  totEl && (totEl.textContent = '$' + total);

  if (upsell) {
    const hasStickies = cart.items.some(item =>
      item.product_title.includes('Sticky') || item.product_title.includes('Notebook')
    );
    upsell.style.display = hasStickies ? 'none' : 'block';
  }
}

async function upsellAdd(variantId, btn) {
  btn.disabled = true;
  const label = btn.textContent;
  try {
    const added = await window.StoryStock.add({ id: variantId, quantity: 1, handle: btn.dataset.productHandle });
    if (added) { btn.textContent = '✓'; await refreshCart(); }
  } catch (error) { window.alert(error.message); }
  finally { btn.disabled = false; if (btn.textContent !== '✓') btn.textContent = label; }
}

async function cartUpdateLine(key, quantity) {
  try { await window.StoryStock.change(key, quantity); await refreshCart(); }
  catch (error) { window.alert(error.message); }
}

/* ── Product Page: Add to Cart ── */
const atcForm = document.getElementById('atcForm');
let productAddBusy = false;
let productStockRequest = 0;
if (atcForm) {
  atcForm.addEventListener('submit', function(e) {
    e.preventDefault();
    addProductWithStock(false);
  });
  refreshProductStock();
  window.addEventListener('pageshow', refreshProductStock);
  window.addEventListener('focus', refreshProductStock);
}

function productStockMessage(message) {
  const el = document.getElementById('productStockMessage');
  if (el) { el.textContent = message || ''; el.hidden = !message; }
}

async function refreshProductStock() {
  if (!atcForm) return;
  const request = ++productStockRequest;
  const id = document.getElementById('variantId').value;
  const qty = Number(document.getElementById('qtyInput').value) || 1;
  let state;
  try {
    const stock = await window.StoryStock.read(atcForm.dataset.productHandle, id);
    state = window.StoryStock.classify(stock, qty);
  } catch (_) { state = 'unknown'; }
  if (request !== productStockRequest) return;
  const available = state !== 'unavailable';
  const preorder = state === 'preorder';
  const text = preorder ? 'Available for pre-order' : state === 'in_stock' ? 'Available now'
    : state === 'unavailable' ? 'Currently unavailable' : 'Stock check unavailable';
  const stockEl = document.querySelector('.product-stock');
  const badge = document.querySelector('.product-cover-badge');
  if (stockEl) {
    stockEl.className = 'product-stock' + (preorder ? ' stock-preorder' : !available ? ' stock-out' : '');
    stockEl.innerHTML = '<div class="stock-dot"></div>' + text;
  }
  if (badge) {
    badge.textContent = text;
    badge.className = 'product-cover-badge' + (preorder ? ' badge-preorder' : !available ? ' badge-unavailable' : '');
  }
  const btn = document.getElementById('atcBtn');
  btn.hidden = preorder;
  btn.disabled = !available || productAddBusy;
  btn.classList.toggle('product-atc-disabled', !available);
  document.getElementById('atcLabel').textContent = state === 'unknown' ? 'Check availability'
    : available ? 'Add to Cart' : 'Currently unavailable';
  const preBtn = document.getElementById('preorderBtn');
  preBtn.hidden = !preorder;
  preBtn.disabled = productAddBusy;
}

async function addProductWithStock(confirmed) {
  if (productAddBusy) return;
  productAddBusy = true;
  productStockMessage('');
  document.getElementById('atcBtn').disabled = true;
  document.getElementById('preorderBtn').disabled = true;
  try {
    const added = await window.StoryStock.add({
      id: Number(document.getElementById('variantId').value),
      quantity: Number(document.getElementById('qtyInput').value) || 1,
      handle: atcForm.dataset.productHandle,
      confirmPreorder: () => { if (confirmed) return true; openPreOrderModal(); return false; }
    });
    if (added) { closePreOrderModal(); await refreshCart(); openCart(); }
  } catch (error) {
    closePreOrderModal();
    productStockMessage(error.message);
  } finally {
    productAddBusy = false;
    refreshProductStock();
  }
}

/* ── Product Page: Quantity Stepper ── */
function changeQty(delta) {
  const inp = document.getElementById('qtyInput');
  const display = document.getElementById('qtyDisplay');
  if (!inp) return;
  let val = Math.max(1, parseInt(inp.value) + delta);
  inp.value = val;
  display && (display.textContent = val);
  refreshProductStock();
}

/* ── Pre-Order Modal ── */
function openPreOrderModal() {
  const overlay = document.getElementById('preorderOverlay');
  const modal   = document.getElementById('preorderModal');
  if (!overlay || !modal) return;
  overlay.style.display = 'block';
  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closePreOrderModal() {
  const overlay = document.getElementById('preorderOverlay');
  const modal   = document.getElementById('preorderModal');
  if (!overlay || !modal) return;
  overlay.style.display = 'none';
  modal.classList.remove('open');
  document.body.style.overflow = '';
  const btn = document.getElementById('preorderConfirmBtn');
  if (btn) { btn.disabled = false; btn.textContent = 'Yes, pre-order it'; }
}

async function confirmPreOrder() {
  const btn = document.getElementById('preorderConfirmBtn');
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
  await addProductWithStock(true);
}

/* ══ VARIANT PICKER ══ */
(function () {
  const picker = document.getElementById('variantPicker');
  if (!picker) return;

  const swatches = Array.from(picker.querySelectorAll('.variant-swatch'));
  const idInput  = document.getElementById('variantId');
  const valueEl  = document.getElementById('variantOptionValue');
  const priceEl  = document.querySelector('.product-price');
  const coverEl  = document.querySelector('.product-cover');
  const stockEl  = document.querySelector('.product-stock');
  const badgeEl  = document.querySelector('.product-cover-badge');

  function selectVariant(btn) {
    swatches.forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');

    if (idInput) idInput.value = btn.dataset.variantId;
    if (valueEl) valueEl.textContent = btn.dataset.title;
    if (priceEl) priceEl.textContent = btn.dataset.price;
    if (coverEl && btn.dataset.image) coverEl.src = btn.dataset.image;

    /* Three states, not two. A variant can be on the shelf, sellable but
       empty (pre-order), or gone entirely. The old code only knew
       available/not, so picking an in-stock cover on a product whose first
       cover was pre-order left the Pre-Order button sitting there. */
    const available = btn.dataset.available === 'true';
    const preorder  = btn.dataset.preorder === 'true';

    if (stockEl) {
      stockEl.className = !available ? 'product-stock stock-out'
                        : preorder   ? 'product-stock stock-preorder'
                        :              'product-stock';
      stockEl.innerHTML = '<div class="stock-dot"></div>' +
        (!available ? 'Currently unavailable'
         : preorder ? 'Available for pre-order'
         :            'Available now');
    }
    if (badgeEl) {
      badgeEl.className = !available ? 'product-cover-badge badge-unavailable'
                        : preorder   ? 'product-cover-badge badge-preorder'
                        :              'product-cover-badge';
      badgeEl.textContent = !available ? 'Currently unavailable'
                          : preorder   ? 'Pre-order'
                          :              'Available now';
    }

    // Re-query each time — the add-to-cart button rewrites its own contents
    const atcBtn   = document.getElementById('atcBtn');
    const atcLabel = document.getElementById('atcLabel');
    const preBtn   = document.getElementById('preorderBtn');
    if (atcBtn) {
      atcBtn.hidden = preorder;
      atcBtn.disabled = !available;
      atcBtn.classList.toggle('product-atc-disabled', !available);
    }
    if (preBtn) preBtn.hidden = !preorder;
    if (atcLabel) atcLabel.textContent = available ? 'Add to Cart' : 'Currently unavailable';
    refreshProductStock();
  }

  swatches.forEach(function (btn) {
    btn.addEventListener('click', function () { selectVariant(btn); });
  });
})();

/* ══ GIFT BOX ══ */

let giftSaveTimer = null;
let giftBusy      = false;

function isGiftItem(item) {
  return !!window.GIFT_BOX_ID && item.variant_id === window.GIFT_BOX_ID;
}

/* Reflect the cart's gift state in the UI — runs on every cart render */
function renderGiftState(cart) {
  const block = document.getElementById('giftBlock');
  if (!block) return;

  block.style.display = 'block';

  // A toggle is still in flight — don't overwrite what the customer just clicked
  if (giftBusy) return;

  const on     = cart.items.some(isGiftItem);
  const box    = document.getElementById('giftCheckbox');
  const fields = document.getElementById('giftFields');

  if (box) box.checked = on;
  block.classList.toggle('gift-on', on);
  if (fields) fields.style.display = on ? 'block' : 'none';

  // Don't overwrite what the customer is part-way through typing
  if (!on || giftSaveTimer) return;

  const attrs = cart.attributes || {};
  const toEl  = document.getElementById('giftTo');
  if (toEl && document.activeElement !== toEl) toEl.value = attrs['Gift recipient'] || '';
}

async function toggleGiftBox(checked) {
  if (!window.GIFT_BOX_ID) return;

  const fields = document.getElementById('giftFields');
  if (fields) fields.style.display = checked ? 'block' : 'none';

  const onCartPage = window.location.pathname === '/cart';

  giftBusy = true;
  try {
    if (checked) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: window.GIFT_BOX_ID, quantity: 1 })
      });
    } else {
      const toEl = document.getElementById('giftTo');
      if (toEl) toEl.value = '';
      await removeGiftBox();
    }
  } catch (err) {
    console.error('Gift box toggle failed', err);
  } finally {
    giftBusy = false;
  }

  // The cart page renders its totals server-side — reload so they're right
  if (onCartPage) { window.location.reload(); return; }

  await refreshCart();

  if (checked) {
    const toEl = document.getElementById('giftTo');
    if (toEl) toEl.focus();
  }
}

async function removeGiftBox() {
  if (!window.GIFT_BOX_ID) return;
  // change.js matches on the line key. A bare variant id doesn't match and
  // fails silently, which left the box in the cart and flipped the box back on.
  const cart = await fetch('/cart.js').then(r => r.json());
  const line = cart.items.find(isGiftItem);
  if (line) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 })
    });
  }
  await saveGiftDetails('');
}

/* Debounced so we aren't writing to the cart on every keystroke */
function queueGiftSave() {
  clearTimeout(giftSaveTimer);
  giftSaveTimer = setTimeout(function() {
    const toEl = document.getElementById('giftTo');
    saveGiftDetails(toEl ? toEl.value : '');
    giftSaveTimer = null;
  }, 600);
}

async function saveGiftDetails(to) {
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Gift recipient': (to || '').slice(0, 40),
          // Card messages were removed. An empty value deletes the attribute,
          // so a message typed into a cart before the change never reaches
          // an order.
          'Gift message':   ''
        }
      })
    });
  } catch (err) {
    console.error('Gift details save failed', err);
  }
}

/* ── Init cart badge + gift state on page load ── */
fetch('/cart.js')
  .then(r => r.json())
  .then(function(cart) {
    updateCartBadge(cartItemCount(cart));
    renderGiftState(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  })
  .catch(() => {});

/* ── HTML escape helper ── */
function esc(s) {
  return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

/* ── Filter Sidebar ── */
(function() {
  var overlay = document.getElementById('filterOverlay');
  var sidebar = document.getElementById('filterSidebar');
  if (!overlay || !sidebar) return;

  var urlParams = new URLSearchParams(window.location.search);

  function openFilter() {
    sidebar.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';

    // Pre-check genres from URL or current collection
    sidebar.querySelectorAll('.genre-cb').forEach(function(cb) { cb.checked = false; });
    var genresParam = urlParams.get('genres');
    if (genresParam) {
      var handles = genresParam.split(',');
      sidebar.querySelectorAll('.genre-cb').forEach(function(cb) {
        if (handles.indexOf(cb.dataset.handle) !== -1) cb.checked = true;
      });
    } else {
      var handle = window.__collectionHandle;
      if (handle && handle !== 'all') {
        var match = sidebar.querySelector('.genre-cb[data-handle="' + handle + '"]');
        if (match) match.checked = true;
      }
    }

    // Pre-select sort
    var currentSort = urlParams.get('sort_by') || '';
    sidebar.querySelectorAll('input[name="filterSort"]').forEach(function(r) { r.checked = false; });
    var sortMatch = sidebar.querySelector('input[name="filterSort"][value="' + currentSort + '"]');
    var sortDef   = sidebar.querySelector('input[name="filterSort"][value=""]');
    if (sortMatch) sortMatch.checked = true;
    else if (sortDef) sortDef.checked = true;
  }

  function closeFilter() {
    sidebar.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function clearFilter() {
    sidebar.querySelectorAll('.genre-cb').forEach(function(cb) { cb.checked = false; });
    var def = sidebar.querySelector('input[name="filterSort"][value=""]');
    if (def) def.checked = true;
  }

  function applyFilter() {
    var checked    = Array.from(sidebar.querySelectorAll('.genre-cb:checked'));
    var totalGenres = sidebar.querySelectorAll('.genre-cb').length;
    var sortEl     = sidebar.querySelector('input[name="filterSort"]:checked');
    var sort       = sortEl ? sortEl.value : '';
    var url;

    closeFilter();

    // No genres or all genres → show everything
    if (checked.length === 0 || checked.length >= totalGenres) {
      url = '/collections/all';
      if (sort) url += '?sort_by=' + encodeURIComponent(sort);
      window.location.href = url;
      return;
    }

    // Single genre → go to that collection
    if (checked.length === 1) {
      url = '/collections/' + checked[0].dataset.handle;
      if (sort) url += '?sort_by=' + encodeURIComponent(sort);
      window.location.href = url;
      return;
    }

    // Multiple genres → navigate to /collections/all with genres param, then filter client-side
    var handles = checked.map(function(cb) { return cb.dataset.handle; });
    url = '/collections/all?genres=' + handles.join(',');
    if (sort) url += '&sort_by=' + encodeURIComponent(sort);
    window.location.href = url;
  }

  overlay.addEventListener('click', closeFilter);
  var closeBtn = document.getElementById('filterCloseBtn');
  var clearBtn = document.getElementById('filterClearBtn');
  var applyBtn = document.getElementById('filterApplyBtn');
  if (closeBtn) closeBtn.addEventListener('click', closeFilter);
  if (clearBtn) clearBtn.addEventListener('click', clearFilter);
  if (applyBtn) applyBtn.addEventListener('click', applyFilter);

  window.openFilterSidebar = openFilter;

  // ── Client-side multi-genre filter (runs on /collections/all?genres=...) ──
  var genresParam = urlParams.get('genres');
  if (genresParam && window.__collectionHandle === 'all') {
    var handleToType = {
      'romance': 'Romance',
      'dark-romance': 'Dark Romance',
      'fantasy': 'Fantasy',
      'thriller': 'Thriller',
      'arabic-books': 'Arabic',
      'business-amp-self-help': 'Business & Self-Help',
      'classics': 'Classics'
    };
    var selectedHandles = genresParam.split(',');
    var selectedTypes = selectedHandles.map(function(h) { return handleToType[h]; }).filter(Boolean);
    if (selectedTypes.length > 0) {
      var sort = urlParams.get('sort_by') || '';
      runClientFilter(selectedTypes, sort);
    }
  }

  function runClientFilter(selectedTypes, sort) {
    var grid = document.querySelector('.collection-grid');
    var countLabel = document.querySelector('.collection-count-label');
    if (!grid) return;

    grid.innerHTML = '<p style="color:var(--gray);grid-column:1/-1;padding:40px 0;text-align:center;font-family:\'DM Sans\',sans-serif">Loading…</p>';
    if (countLabel) countLabel.textContent = 'Loading…';

    var allProducts = [];

    function fetchPage(page) {
      return fetch('/collections/all/products.json?limit=250&page=' + page)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          allProducts = allProducts.concat(data.products);
          if (data.products.length === 250) return fetchPage(page + 1);
        });
    }

    fetchPage(1).then(function() {
      var filtered = allProducts.filter(function(p) {
        return selectedTypes.indexOf(p.product_type) !== -1;
      });

      if (sort === 'title-ascending')  filtered.sort(function(a, b) { return a.title.localeCompare(b.title); });
      if (sort === 'title-descending') filtered.sort(function(a, b) { return b.title.localeCompare(a.title); });
      if (sort === 'price-ascending')  filtered.sort(function(a, b) { return parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price); });
      if (sort === 'price-descending') filtered.sort(function(a, b) { return parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price); });

      if (countLabel) countLabel.textContent = filtered.length + ' titles';

      if (filtered.length === 0) {
        grid.innerHTML = '<p style="color:var(--gray);grid-column:1/-1;padding:40px 0;font-family:\'DM Sans\',sans-serif">No books found for the selected genres.</p>';
        return;
      }

      grid.innerHTML = filtered.map(function(p) {
        var img   = p.images.length > 0 ? p.images[0].src : '';
        var price = '$' + Math.round(parseFloat(p.variants[0].price));
        return '<a href="/products/' + p.handle + '" class="book-card">' +
          '<div class="book-card-inner">' +
            '<div class="book-card-wrap">' +
              (img ? '<img class="book-card-img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<div class="book-card-img" style="background:var(--surface)"></div>') +
              '<div class="book-card-shine"></div>' +
            '</div>' +
            '<div class="book-card-genre">' + esc(p.product_type || '') + '</div>' +
            '<div class="book-card-title">' + esc(p.title) + '</div>' +
            '<div class="book-card-price">' + price + '</div>' +
          '</div>' +
        '</a>';
      }).join('');
    }).catch(function() {
      grid.innerHTML = '<p style="color:var(--gray);grid-column:1/-1;padding:40px 0;font-family:\'DM Sans\',sans-serif">Something went wrong. Please try again.</p>';
    });
  }
})();

/* ── Welcome popup ── */
(function() {
  if (localStorage.getItem('tss_welcome_shown')) return;
  if (window.CAMPAIGN && Date.now() < new Date(window.CAMPAIGN.end).getTime()) return;
  setTimeout(function() {
    const overlay = document.getElementById('welcomeOverlay');
    if (overlay) overlay.classList.add('show');
  }, 3500);
})();

function closeWelcomePopup() {
  const overlay = document.getElementById('welcomeOverlay');
  if (overlay) overlay.classList.remove('show');
  localStorage.setItem('tss_welcome_shown', '1');
}

function submitWelcomeForm(e) {
  e.preventDefault();
  var name  = (document.getElementById('wName')  || {}).value || '';
  var email = (document.getElementById('wEmail') || {}).value || '';

  if (email) {
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        'form_type': 'customer',
        'utf8': '✓',
        'customer[first_name]': name,
        'customer[email]': email,
        'customer[tags]': 'welcome-discount'
      }).toString()
    }).catch(function() {});
  }

  localStorage.setItem('tss_welcome_shown', '1');
  document.getElementById('welcomeStep1').style.display = 'none';
  document.getElementById('welcomeStep2').style.display = 'block';
}

function copyWelcomeCode() {
  const btn = document.getElementById('copyCodeBtn');
  navigator.clipboard.writeText('WELCOME20').then(function() {
    if (btn) {
      btn.textContent = 'Copied';
      setTimeout(function() { btn.textContent = 'Copy code'; }, 2000);
    }
  }).catch(function() {
    if (btn) {
      btn.textContent = 'Code: WELCOME20';
      setTimeout(function() { btn.textContent = 'Copy code'; }, 3000);
    }
  });
}

/* ── Mark active nav link ── */
const currentPath = window.location.pathname;
document.querySelectorAll('.nav-link').forEach(link => {
  const href = link.getAttribute('href');
  if (href === currentPath || (href !== '/' && currentPath.startsWith(href))) {
    link.classList.add('active');
  }
});

/* ══ CELEBRATION MODE ══ */
(function () {
  var C = window.CAMPAIGN;
  if (!C || C.kind !== 'milestone') return;

  var endMs = new Date(C.end).getTime();
  if (Date.now() > endMs) return;

  var daysLeft = Math.ceil((endMs - Date.now()) / 86400000);
  var label = C.milestone >= 1000 ? (C.milestone / 1000) + 'K' : C.milestone;

  /* ── Override marquee ── */
  function overrideMarquee() {
    var parts = [
      label + ' followers — thank you',
      C.percent + '% off when you buy ' + C.minBooks + '+ books',
      'Applied automatically · no code needed',
      daysLeft + ' day' + (daysLeft !== 1 ? 's' : '') + ' left',
      'Cash on delivery',
      'Delivery all over Lebanon · 4–5 business days'
    ];
    var html = parts.map(function (s) { return '<span class="marquee-dot"></span> ' + s + ' '; }).join('');
    document.querySelectorAll('.marquee-item').forEach(function (el) { el.innerHTML = html; });
    var bar = document.querySelector('.announce');
    if (bar) bar.classList.add('announce-celeb');
  }

  /* ── Homepage banner ── */
  function injectBanner() {
    if (window.location.pathname !== '/') return;
    var sparks = [1,2,3,4,5,6].map(function (i) {
      return '<span class="celeb-spark celeb-spark-' + i + '"></span>';
    }).join('');
    var banner = document.createElement('div');
    banner.className = 'celeb-banner';
    banner.innerHTML =
      '<div class="celeb-banner-sparks" aria-hidden="true">' + sparks + '</div>' +
      '<div class="celeb-banner-inner">' +
        '<p class="celeb-banner-eyebrow">a milestone worth celebrating</p>' +
        '<div class="celeb-banner-number">' + label + '</div>' +
        '<p class="celeb-banner-readers">readers on Instagram</p>' +
        '<p class="celeb-banner-offer">' + C.percent + '% off when you buy ' + C.minBooks + ' or more books · Applied automatically at checkout</p>' +
        '<div class="celeb-banner-countdown">' + daysLeft + ' day' + (daysLeft !== 1 ? 's' : '') + ' left</div>' +
        '<a href="/collections/all" class="celeb-banner-btn">Browse Books</a>' +
      '</div>';
    var main = document.getElementById('main-content');
    if (main) main.insertAdjacentElement('afterbegin', banner);
  }

  /* ── Confetti ── */
  function runConfetti() {
    var canvas = document.getElementById('celebCanvas');
    if (!canvas || sessionStorage.getItem('celebConfetti_' + C.milestone)) return;
    sessionStorage.setItem('celebConfetti_' + C.milestone, '1');
    canvas.style.display = 'block';
    var ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    var colors = ['#B8956A', '#E8C99A', '#D4AF82', '#1C2B4A', '#FFFFFF', '#F5E6D3'];
    var particles = Array.from({ length: 130 }, function () {
      return {
        x: Math.random() * canvas.width,
        y: -30 - Math.random() * 120,
        w: 5 + Math.random() * 9,
        h: 2 + Math.random() * 5,
        color: colors[Math.floor(Math.random() * colors.length)],
        speed: 2.5 + Math.random() * 3.5,
        wobble: Math.random() * Math.PI * 2,
        wobbleSpeed: 0.04 + Math.random() * 0.07,
        rot: Math.random() * Math.PI * 2,
        rotSpeed: (Math.random() - 0.5) * 0.12,
        alpha: 1
      };
    });
    var start = null;
    var duration = 4200;
    function frame(ts) {
      if (!start) start = ts;
      var p = (ts - start) / duration;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(function (pt) {
        pt.y += pt.speed;
        pt.wobble += pt.wobbleSpeed;
        pt.x += Math.sin(pt.wobble) * 1.8;
        pt.rot += pt.rotSpeed;
        if (p > 0.65) pt.alpha = Math.max(0, 1 - (p - 0.65) / 0.35);
        ctx.save();
        ctx.globalAlpha = pt.alpha;
        ctx.translate(pt.x, pt.y);
        ctx.rotate(pt.rot);
        ctx.fillStyle = pt.color;
        ctx.fillRect(-pt.w / 2, -pt.h / 2, pt.w, pt.h);
        ctx.restore();
      });
      if (p < 1) requestAnimationFrame(frame);
      else canvas.style.display = 'none';
    }
    requestAnimationFrame(frame);
  }

  /* ── Popup ── */
  function showPopup() {
    if (sessionStorage.getItem('celebPopup_' + C.milestone)) return;
    sessionStorage.setItem('celebPopup_' + C.milestone, '1');

    var overlay = document.getElementById('celebOverlay');
    if (!overlay) return;

    var numEl = document.getElementById('celebNumber');
    var cdEl  = document.getElementById('celebCountdown');
    if (numEl) numEl.textContent = label;
    if (cdEl)  cdEl.textContent  = daysLeft + ' day' + (daysLeft !== 1 ? 's' : '') + ' left';

    function close() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    var closeBtn  = document.getElementById('celebClose');
    var skipBtn   = document.getElementById('celebSkip');
    var browseBtn = document.getElementById('celebBrowseBtn');
    if (closeBtn)  closeBtn.addEventListener('click', close);
    if (skipBtn)   skipBtn.addEventListener('click', close);
    if (browseBtn) browseBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    setTimeout(function () {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      runConfetti();
    }, 700);
  }

  /* ── Init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      overrideMarquee();
      injectBanner();
      showPopup();
    });
  } else {
    overrideMarquee();
    injectBanner();
    showPopup();
  }
})();
